var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-form-item',{attrs:{"label":"TenantId"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:(_vm.decorators.tenant_id),expression:"decorators.tenant_id"}],attrs:{"placeholder":_vm.$t('common_524')}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }